"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AddChildDomain {
    static getAttributeTypeMap() {
        return AddChildDomain.attributeTypeMap;
    }
}
AddChildDomain.discriminator = undefined;
AddChildDomain.attributeTypeMap = [
    {
        "name": "domain",
        "baseName": "domain",
        "type": "string"
    }
];
exports.AddChildDomain = AddChildDomain;
//# sourceMappingURL=addChildDomain.js.map